import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
/**
 * 表单标签内容组件
 *
 * @ReactComponent
 */
var FormLabelContent = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    return props.required &&
        (props.align === 'right' ? '&::before' : '&::after') + " {\n    content: \"*\";\n    padding: 0 4px;\n  }";
});
export default FormLabelContent;
var templateObject_1;
//# sourceMappingURL=FormLabelContent.js.map